import { cn, NoddiIcon } from 'noddi-ui-common';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '../../../base/empty';
import { NoddiEmptyProps } from './types';

type Props = NoddiEmptyProps & {
  size?: 'small' | 'medium';
};

export const NoddiEmptyContent = ({ message = '', title, children, emptyIcon, size = 'medium' }: Props) => {
  const description = message.endsWith('.') ? message.slice(0, -1) : message;
  const isSmall = size === 'small';

  return (
    <Empty className={cn(isSmall && 'flex-none gap-3 p-3 md:p-4')}>
      <EmptyHeader className={cn(isSmall && 'gap-1.5')}>
        <EmptyMedia variant='icon' className={cn(isSmall && "size-8 [&_svg:not([class*='size-'])]:size-4")}>
          <NoddiIcon name={emptyIcon ?? 'Info'} />
        </EmptyMedia>
        <EmptyTitle className={cn(isSmall && 'text-sm')}>{title}</EmptyTitle>
        <EmptyDescription className={cn(isSmall && 'text-xs')}>{description}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent className={cn(isSmall && 'gap-2')}>{children}</EmptyContent>
    </Empty>
  );
};
